/* eslint react/require-default-props: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Table from '../Table';
import getRows from './helpers/getRows';
import getColumns from './helpers/getColumns';
import getSingleRow from './helpers/getSingleRow';
import { ACTIONS } from '../../constants/strings';
import { getFlatQuestionsWithPosition } from './helpers/getFlatQuestionsWithPosition';

const Review = ({
  date,
  questions,
  scorecard,
  exportPDF,
  assignments,
  assignmentId,
  intl: { formatMessage },
  isProviderPostVisitForm,
}) => {
  const flatQuestions = getFlatQuestionsWithPosition(questions);

  const isSingleViewResult = assignments && assignments.length === 1;

  const triggeredDaysMap = {};
  const cols = getColumns(assignments, triggeredDaysMap);
  const rows = getRows(flatQuestions, assignments, isSingleViewResult);
  const totalRow = scorecard
    ? getSingleRow(
        assignments,
        ['totalScore', 'totalScoreTriggered'],
        formatMessage(ACTIONS.survey.totalScore),
      )
    : null;
  const userRow = getSingleRow(
    assignments,
    ['respondent', 'originalRespondent'],
    'Respondent:',
  );
  const assignmentRow = getSingleRow(
    assignments,
    ['assignmentMethod', 'assigner'],
    `${formatMessage({ id: 'surveys.assignedBy' })}:`,
  );

  const options = {
    cols,
    rows,
    userRow,
    totalRow,
    exportPDF,
    assignmentRow,
    assignmentId,
  };

  return (
    <div>
      <Table
        {...options}
        singleData={!!date}
        isProviderPostVisitForm={isProviderPostVisitForm}
      />
    </div>
  );
};

Review.propTypes = {
  exportPDF: PropTypes.func,
  scorecard: PropTypes.bool,
  assignmentId: PropTypes.number,
  isProviderPostVisitForm: PropTypes.bool,
  intl: PropTypes.shape({ formatMessage: PropTypes.func }),
  date: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  questions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      text: PropTypes.string,
    }),
  ),
  assignments: PropTypes.arrayOf(
    PropTypes.shape({
      answers: PropTypes.array,
      sentAt: PropTypes.string,
      assignmentId: PropTypes.number,
    }),
  ),
};

export default injectIntl(Review);



// WEBPACK FOOTER //
// ./src/components/Survey/Review.jsx